import { useEffect, useRef, useState } from 'react';
import debounce from '~/utilities/debounce';

export default function useCurrentSection(
  validSectionIds: string[] = [],
  topOffset = 0
) {
  const [currentSection, setCurrentSection] = useState('');
  const validSectionIdsRef = useRef<string[]>([]);
  const topOffsetRef = useRef(topOffset);

  useEffect(() => {
    topOffsetRef.current = topOffset;
  }, [topOffset]);

  useEffect(() => {
    validSectionIdsRef.current = validSectionIds;
  }, [validSectionIds]);

  useEffect(() => {
    const setCurrentNavTabBasedOnScroll = debounce(() => {
      const allSections = [
        ...document.querySelectorAll<HTMLElement>('[data-nav-section]')
      ];

      const navSections = validSectionIdsRef.current
        ? allSections.filter(section =>
            validSectionIdsRef.current.includes(
              section.dataset.navSection || ''
            )
          )
        : allSections;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      let scrollSection = '';

      for (const section of navSections) {
        const rect = section.getBoundingClientRect();
        const sectionTop = rect.top + scrollTop;
        const sectionBottom = sectionTop + rect.height;
        if (
          scrollTop >= sectionTop - topOffsetRef.current &&
          scrollTop <= sectionBottom - topOffsetRef.current
        ) {
          scrollSection = section.dataset.navSection || '';
          break;
        }
      }

      setCurrentSection(scrollSection);
    }, 50);

    window.addEventListener('scroll', setCurrentNavTabBasedOnScroll, {
      passive: true
    });

    return () => {
      window.removeEventListener('scroll', setCurrentNavTabBasedOnScroll);
    };
  }, []);

  return currentSection;
}
